"use client";

import React from "react";

import { Nav } from "@/components/nav";
import { useAppSelector } from "@/services/hooks/redux.hooks";

import { ExchangeSwitcher } from "./global/exchange-swticher";
import LogoText from "./global/LogoText";

export default function MobileSidebar() {
  const isCollapsed = useAppSelector(
    (state) => state.exchangeSwitcher.isSideBarCollapsed,
  );
  const { options } = useAppSelector((state) => state.sidebar);

  return (
    <div className="pb-10 overflow-auto">
      <div className="pb-2 mt-4 px-2 border-b-[1px]">
        <LogoText className="h-8" />
      </div>
      <ExchangeSwitcher />

      <Nav isCollapsed={isCollapsed} links={options} />
    </div>
  );
}
